import { SdohReferralStatusReason } from './sdoh-status-reason.model';

export enum SdohSubmissionType {
  AP = 'AP',
  AS = 'AS',
  TS = 'TS',
}

export enum SdohSubmissionTypeLabel {
  ActionPlan = 'Action Plan',
  Assessment = 'Assessment'
}

export enum SdohSubmissionStatus {
  UpdateRequested = 'UpdateRequested',
  InternalReview = 'InternalReview',
  Submitted = 'Submitted',
  InProgress = 'InProgress'
}

export const SdohSubmissionStatusLabelMap: { [key: string]: string } = {
  [SdohSubmissionStatus.UpdateRequested]: 'Update Requested',
  [SdohSubmissionStatus.InternalReview]: 'Internal Review',
  [SdohSubmissionStatus.Submitted]: 'Submitted',
  [SdohSubmissionStatus.InProgress]: 'In Progress'
};

export interface SdohSubmissionNotifications {
  comment: string;
  createdBy: string;
  createdOn: Date | string;
  isResolved: boolean;
  modifiedBy: string;
  modifiedOn: Date | string;
  referralNotificationId: string;
  referralSubmissionId: string;
}

export interface SdohSubmissionFormData {
  formId: string;
  formRevision: number;
  formSubmissionId: string;
  referralFormDataId: string;
  createdBy: string;
  createdOn: Date | string;
  modifiedBy: string;
  modifiedOn: Date | string;
}

export interface SdohSubmission {
  createdBy: string;
  createdOn: Date | string;
  modifiedBy: string;
  modifiedOn: Date | string;
  submittedBy: string;
  submittedOn: Date | string;
  notifications: SdohSubmissionNotifications[];
  referenceNumber: string;
  referralFormData: SdohSubmissionFormData;
  formId: string;
  formRevision: number;
  formSubmissionId: string;
  referralFormDataId: string;
  referralId: string;
  referralSubmissionId: string;
  status: SdohSubmissionStatus;
  statusReason: SdohReferralStatusReason;
  tenantId: string;
  tenantName: string;
  type: SdohSubmissionType;
}
